import * as Actions from '../actions/overallsummary.actions';
import * as Constants from '../actions/overallsummary.constants';
import { OverallSummaryReportState } from '../types/overallsummaryreport-state';

const defaultState: Partial<OverallSummaryReportState> = {
  loading: false,
  data: [],
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear()
};

export function reducer(
  state: Partial<OverallSummaryReportState> = defaultState,
  action: Actions.All
): Partial<OverallSummaryReportState> {
  switch (action.type) {
    case Constants.INITIALIZE:
    case Constants.DESTROY: {
      return { ...defaultState };
    }
    case Constants.UPDATE_QUERY: {
      const { month, year } = action as Actions.UpdateQueryAction;
      return { ...state, loading: true, month, year };
    }
    case Constants.REPORT_LOADED: {
      const { data } = action as Actions.ReportLoadedAction;
      return { ...state, loading: false, data };
    }
    default:
      return state;
  }
}